module.exports = __webpack_public_path__ + "static/img/role-wd-type-c1508018.94d155b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role-wd-type-c1508018.png
// module id = G8bQ
// module chunks = 1